<template>
  <div>
    <div class="tw-mx-auto px-body tw-mt-8 tw-pb-8 tw-border-b" v-if="experts.length">
      <div class="tw-flex tw-items-center">
        <h5 class="tw-text-lg font-title tw-pr-5">
          Experts
        </h5>
        <div class="tw-flex-grow">
          <swiper
            :options="expertsSwiperOptions"
            ref="my-meetings-slider"
            :key="meetingsSlideKey"
          >
            <swiper-slide
              v-for="(expert, key) in experts"
              :key="key"
              :class="[
                'tw-shrink-0 tw-w-auto tw-h-auto',
              ]"
              style="height: auto;"
            >
              <router-link :to="{ name: 'ExpertView', params: { id: expert.id }}">
                <div class="tw-text-center">
                  <UserPhoto
                    :alt="`${expert.name} ${expert.last_name}`"
                    :photo="expert.pic"
                    photo-size="tw-w-20 tw-h-20"
                    class="tw-rounded-full tw-bg-gray-200 tw-object-cover tw-cursor-pointer"
                  />
                  <p class="tw-mt-1 tw-text-xs">{{ expert.name }} {{ expert.last_name }}</p>
                </div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { now } from '../../modules/dataHelper';

export default {
  name: 'ProgramExperts',
  data() {
    return {
      experts: [],
      expertsSwiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        observer: true,
        centeredSlides: false,
        // breakpoints: {
        //   // screenWidth <=767px
        //   767: {
        //     slidesPerView: 3.5,
        //     spaceBetween: 10,
        //   },
        // },
      },
    };
  },
  computed: {
    meetingsSlideKey() {
      // eslint-disable-next-line no-unused-expressions
      this.updatedSlideCounts;
      return now();
    },
  },
  methods: {
    async getExperts() {
      const experts = await this.$store.dispatch('getCompanyProgramExperts');

      if (Array.isArray(experts)) {
        this.experts = experts;
      }
    },
    goToExpert(expertId) {
      this.$router.push({ name: 'ExpertView', params: { id: expertId } });
    },
  },
  async created() {
    await this.$nextTick();
    await this.getExperts();
  },
};
</script>

<style>

</style>
